import { ref, onMounted, onUnmounted, nextTick } from 'vue';

/**
 * 让原来的 FilterSelect, MultiSelect, SingleSelect 等组件支持 fixed 定位
 */
export function useFixedDropdown(fixed) {
  const buttonRef = ref(null);
  const buttonPosition = ref({ top: 0, left: 0, width: 0, height: 0 });

  const updateButtonPosition = () => {
    if (buttonRef.value) {
      const rect = buttonRef.value.$el.getBoundingClientRect();
      buttonPosition.value = {
        top: rect.top + rect.height,
        left: rect.left,
        width: rect.width,
        height: rect.height
      };
    }
  };

  const handleToggle = (toggle) => {
    if (fixed.value) {
      updateButtonPosition();
    }
    toggle();
  };

  const handleResize = () => {
    if (fixed.value) {
      updateButtonPosition();
    }
  };

  onMounted(() => {
    if (fixed.value) {
      window.addEventListener('resize', handleResize);
      nextTick(() => {
        updateButtonPosition();
      });
    }
  });

  onUnmounted(() => {
    if (fixed.value) {
      window.removeEventListener('resize', handleResize);
    }
  });

  return {
    buttonRef,
    buttonPosition,
    handleToggle
  };
}
